import { createParser } from "nuqs";

export const parseAsEncodedString = createParser<string>({
    parse: (value) => {
        // Decode any percent-encoding
        const decodedValue = decodeURIComponent(value);
        // Parse any URL encoding
        const key = "key";
        return new URLSearchParams(`${key}=${decodedValue}`).get(key);
    },
    serialize: (value) => (value ? `${value}` : ""),
});
